export default "__VITE_ASSET__CVAHsC3y__"